import Box from '@material-ui/core/Box';
import ButtonBase from '@material-ui/core/ButtonBase';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';

import Highlight from '../Highlight';
import Snippet from '../Snippet';

const ShiftTemplateHit = ({ hit, onClick = () => null, time, propertyDisplayName, userDisplayName, notes }) => {
  const classes = useStyles();
  return (
    <Paper>
      <ButtonBase className={classes.hit} onClick={() => onClick(hit.objectID)}>
        <Box className={classes.box} flexDirection='column'>
          <Highlight
            className={classes.cardTitle}
            attribute='displayName'
            hit={hit}
            align='left'
            noWrap
            variant='h6'
          />
          <Table>
            <TableBody>
              {time && (
                <>
                  <TableRow>
                    <TableCell className={classes.cardProperty}>Time</TableCell>
                    <TableCell align='right'>
                      {
                        moment()
                          .startOf('day')
                          .add(time.startHours, 'hours')
                          .add(time.startMinutes, 'minutes')
                          .format('HH:mm')
                      }
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.cardProperty}>Duration</TableCell>
                    <TableCell align='right'>
                      {`${(time.duration / 3600000).toFixed(2)} hours`}
                    </TableCell>
                  </TableRow>
                </>
              )}
              {Boolean(userDisplayName) && (
                <TableRow>
                  <TableCell className={classes.cardProperty}>Assignee</TableCell>
                  <TableCell align='right'>{userDisplayName}</TableCell>
                </TableRow>
              )}
              {Boolean(propertyDisplayName) && (
                <TableRow>
                  <TableCell className={classes.cardProperty}>Place</TableCell>
                  <TableCell align='right'>{propertyDisplayName}</TableCell>
                </TableRow>
              )}
              {Boolean(notes) && (
                <TableRow>
                  <TableCell className={classes.cardProperty}>Notes</TableCell>
                  <TableCell align='right'>
                    <Snippet className={classes.note} hit={hit} attribute='note' />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Box>
      </ButtonBase>
    </Paper>
  );
};

const useStyles = makeStyles(theme => ({
  hit: {
    width: '100%',
    borderRadius: 4
  },
  box: {
    width: '100%'
  },
  cardTitle: {
    paddingBottom: 14,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 18
  },
  cardProperty: {
    color: theme.palette.text.secondary
  },
  note: {
    fontSize: 14,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}));

const mapStateToProps = (state, ownProps) => {
  const shiftTemplate = state.templates.byId[ownProps.hit.objectID];
  if (shiftTemplate !== undefined) {
    const property = state.properties.byId[shiftTemplate.propertyId];
    const propertyDisplayName = property !== undefined ? property.displayName : null;
    const user = state.users.byId[shiftTemplate.userId];
    const userDisplayName = user !== undefined ? user.displayName : null;
    return {
      time: shiftTemplate.time,
      propertyDisplayName,
      userDisplayName,
      notes: shiftTemplate.note
    };
  } else {
    return {};
  }
};

export default connect(mapStateToProps)(ShiftTemplateHit);
